import * as React from "react";
const SvgLockSmall = ({ title, titleId, ...props }) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.844 8.565C8.844 6.888 10.241 5.5 12 5.5c1.76 0 3.156 1.389 3.156 3.066v.777H8.844v-.777Zm-.753 2.277h8.158c.69 0 1.25.56 1.25 1.25v5.16c0 .69-.56 1.25-1.25 1.25H7.751c-.69 0-1.25-.56-1.25-1.25v-5.16c0-.69.56-1.25 1.25-1.25h.34Zm-.747-1.47v-.807C7.344 6.027 9.445 4 12 4c2.555 0 4.656 2.028 4.656 4.566v.807a2.75 2.75 0 0 1 2.343 2.72v5.16a2.75 2.75 0 0 1-2.75 2.75H7.751A2.75 2.75 0 0 1 5 17.251v-5.16a2.75 2.75 0 0 1 2.343-2.72Zm5.406 5.034c.258-.21.422-.526.422-.88 0-.632-.525-1.144-1.172-1.144-.647 0-1.172.512-1.172 1.145 0 .353.164.67.422.88v2.173a.75.75 0 0 0 1.5 0v-2.174Z"
      fill="currentColor"
    />
  </svg>
);
export default SvgLockSmall;
